import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, Button, Box } from "@mui/material";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./CalendarStyles.css";
import MDTypography from "../../components/MDTypography";
import GenericTable from "../genericTable";
import { createMRTColumnHelper } from "material-react-table";
import dayjs from "dayjs";
import apiService from "../../services/api-service";
import showToast from "../../utils/toast";

function WbsDateCopy({ open, onClose, onCopyWbs }) {
	const [selectedDate, setSelectedDate] = useState(new Date());
	const [wbsData, setWbsData] = useState([]);
	const columnHelper = createMRTColumnHelper();

	const tileDisabled = ({ date }) => {
		const today = new Date();
		return date > today;
	};

	const handleDateChange = (newDate) => {
		setSelectedDate(newDate);
		apiService
			.get(
				"/daily-jobs-management/",
				{
					date: dayjs(newDate).format("YYYY-MM-DD"),
					area_id: localStorage.getItem("areaSelected"),
				},
				{}
			)
			.then((data) => {
				console.log("WBS data from selected date:", data);
				const transformedData = data.map((item) => ({
					...item,
					selected: true,
				}));
				setWbsData(transformedData);
			})
			.catch((error) => {
				showToast("Errore durante il caricamento dei dati WBS. Riprova più tardi.", "error");
			});
	};

	const columns = [
		columnHelper.accessor("code", {
			header: "Codice",
			size: 200,
			Cell: ({ row }) => (
				<MDTypography variant="caption" fontWeight="medium">
					{row.original.code}
				</MDTypography>
			),
		}),
		columnHelper.accessor("description", {
			header: "Descrizione",
			size: 400,
			Cell: ({ row }) => <MDTypography variant="caption">{row.original.description}</MDTypography>,
		}),
	];

	const handleCopy = () => {
		const selectedWbs = wbsData.filter((item) => item.selected);
		onCopyWbs(selectedWbs);
		onClose();
	};

	return (
		<Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
			<DialogTitle>
				<MDTypography variant="h6">Copia WBS da data precedente</MDTypography>
			</DialogTitle>
			<DialogContent>
				<Box sx={{ display: "flex", flexDirection: "column", gap: 2, alignItems: "center", my: 2 }}>
					<Calendar onChange={handleDateChange} value={selectedDate} tileDisabled={tileDisabled} maxDate={new Date()} className="custom-calendar" />

					<MDTypography fontWeight="bold" textTransform="uppercase">
						Data selezionata:
						<br />
						{selectedDate.toLocaleDateString("it-IT", {
							weekday: "long",
							year: "numeric",
							month: "2-digit",
							day: "2-digit",
						})}
					</MDTypography>

					{wbsData.length > 0 && (
						<>
							<GenericTable
								data={wbsData}
								columns={columns}
								enableRowSelection={true}
								enableColumnFilters={false}
								enableGlobalFilter={true}
								enablePagination={true}
								disableButton={true}
								initialSelectedAll={true}
								onRowSelectionChange={(selectedRows) => {
									const updatedWbsData = wbsData.map((item) => ({
										...item,
										selected: selectedRows.some((row) => row.id === item.id),
									}));
									setWbsData(updatedWbsData);
								}}
							/>

							<Button
								variant="contained"
								color="primary"
								onClick={handleCopy}
								sx={{
									backgroundColor: "#514f4f",
									color: "white!important",
									width: "220px",
									height: "50px",
									fontSize: "16px",
								}}
							>
								Copia WBS selezionati
							</Button>
						</>
					)}
				</Box>
			</DialogContent>
		</Dialog>
	);
}

export default WbsDateCopy;
